/**
 * 홈 히어로 한가위 배경 (JCG-3694).
 *
 * 스킨 스위치(`lib/season-skin.ts`)가 chuseok 일 때 `HomeHero` 가 렌더하고, 사용자가 스킨을 끄지 않았을 때만
 * (`season:` variant) 보이며 히어로 기본 배경을 덮는다.
 * 라이트는 해 질 녘 하늘, 다크는 보름밤 하늘에 보름달·구름·색동 띠를 얹는다.
 */
export default function ChuseokHeroBackdrop() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 hidden overflow-hidden season:block"
    >
      <div className="chuseok-sky absolute inset-0" />
      <div className="chuseok-stars absolute inset-0 hidden dark:block" />

      <div className="chuseok-moon absolute -right-6 -top-8 h-28 w-28 rounded-full sm:right-3 sm:top-1/2 sm:h-44 sm:w-44 sm:-translate-y-[58%]" />

      {/* 모바일은 제목과 겹치지 않게 배지 줄 높이에서 달을 가로지른다 */}
      <Cloud className="left-[52%] top-2 w-24 sm:left-auto sm:right-24 sm:top-auto sm:bottom-9 sm:w-44" />
      <Cloud className="bottom-6 left-[46%] hidden w-24 opacity-60 sm:block" />
      <Cloud className="right-[34%] top-4 hidden w-20 -scale-x-100 opacity-50 sm:block" />

      {/* 색동 띠 */}
      <div className="chuseok-saekdong absolute inset-x-0 bottom-0 h-1.5 opacity-80 dark:opacity-70" />
    </div>
  );
}

/** 전통 구름무늬(운문)를 단순화한 구름 */
function Cloud({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 160 60" className={`absolute ${className ?? ""}`} fill="none">
      <path
        d="M8 52H152A16 16 0 0 0 132 32A22 22 0 0 0 94 18A20 20 0 0 0 58 22A16 16 0 0 0 30 34A15 15 0 0 0 8 52Z"
        className="fill-white/90 stroke-violet-200 dark:fill-indigo-200/15 dark:stroke-indigo-200/30"
        strokeWidth="2"
      />
      <path
        d="M86 44a9 9 0 1 1 9-9a5 5 0 1 1-5 5M44 46a7 7 0 1 1 7-7a4 4 0 1 1-4 4"
        className="stroke-violet-200 dark:stroke-indigo-200/30"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
